/**
 * WordPress dependencies
 */
import { forwardRef, useId, useRef } from '@wordpress/element';

/**
 * Internal dependencies
 */
import { ControlWithError } from '../control-with-error';
import { ToggleGroupControl } from '../../toggle-group-control';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const UnforwardedValidatedToggleGroupControl = ({
  required,
  customValidity,
  markWhenOptional,
  ...restProps
}, forwardedRef) => {
  const validityTargetRef = useRef(null);
  const nameAttr = useId();
  return /*#__PURE__*/_jsxs("div", {
    className: "components-validated-control__wrapper-with-error-delegate",
    children: [/*#__PURE__*/_jsx(ControlWithError, {
      required: required,
      markWhenOptional: markWhenOptional,
      customValidity: customValidity,
      getValidityTarget: () => validityTargetRef.current,
      children: /*#__PURE__*/_jsx(ToggleGroupControl, {
        __next40pxDefaultSize: true,
        ref: forwardedRef,
        ...restProps
      })
    }), /*#__PURE__*/_jsx("input", {
      className: "components-validated-control__error-delegate",
      type: "radio",
      ref: validityTargetRef,
      required: required,
      checked: restProps.value !== undefined,
      tabIndex: -1
      // A name attribute is needed for the `required` behavior to work.
      ,
      name: nameAttr,
      onChange: () => {},
      onFocus: e => {
        e.target.previousElementSibling?.querySelector('[data-active-item="true"]')?.focus();
      }
    })]
  });
};
export const ValidatedToggleGroupControl = forwardRef(UnforwardedValidatedToggleGroupControl);